import {Autocomplete, TextField} from "@mui/material";


export interface APXAutoCompleteProps {
	  options: string[];
	  value: string;
	  onOptionSelected: (option: string) => void;
	  textFieldLabel: string;
	  required?: boolean;
	  disabled?: boolean;
	  fullWidth?: boolean;
}


export function APXAutoComplete({options, value, onOptionSelected, textFieldLabel, required = false, disabled = false, fullWidth = true}: APXAutoCompleteProps) {
	  return (
				 <>
						<Autocomplete sx={{ml: 1}}
										  disabled={disabled}
										  clearOnEscape={false}
										  disableClearable fullWidth={fullWidth}
										  options={options ? options : []}
										  renderInput={(params) => (
													 <TextField {...params} required={required} label={textFieldLabel} variant="outlined" fullWidth={fullWidth}
																	inputProps={{...params.inputProps, readOnly: true}}/>
										  )}
										  value={value}
										  onChange={(event, newValue) => {
												 onOptionSelected(newValue);
										  }}
						/>
				 </>
	  );
}
